import React from 'react';

const Timeline = ({ currentStep, steps }) => {
  return (
    <div className="mb-8">
      <div className="relative">
        {/* Progress bar background */}
        <div className="absolute top-5 left-0 w-full h-1 bg-gray-200"></div>
        
        {/* Progress bar fill */}
        <div 
          className="absolute top-5 left-0 h-1 bg-primary-600 transition-all duration-500"
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        ></div>

        {/* Steps */}
        <div className="relative flex justify-between">
          {steps.map((step, index) => {
            const isCompleted = index < currentStep;
            const isCurrent = index === currentStep;
            const isPending = index > currentStep;
            const isLastCompleted = index === currentStep && currentStep === steps.length - 1;

            return (
              <div key={index} className="flex flex-col items-center" style={{ width: `${100 / steps.length}%` }}>
                {/* Step circle */}
                <div
                  className={`
                    w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center z-10 transition-all duration-300
                    ${isCompleted || isLastCompleted ? 'bg-success-600 scale-100' : ''}
                    ${isCurrent && !isLastCompleted ? 'bg-primary-600 scale-110 animate-pulse-slow' : ''}
                    ${isPending ? 'bg-gray-300 scale-90' : ''}
                  `}
                >
                  {(isCompleted || isLastCompleted) ? (
                    <svg className="w-5 h-5 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : isCurrent ? (
                    <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  ) : (
                    <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                  )}
                </div>

                {/* Step label */}
                <div className="mt-2 md:mt-3 text-center px-1 md:px-2">
                  <p
                    className={`
                      text-xs md:text-sm font-medium transition-colors
                      ${isCompleted || isLastCompleted ? 'text-success-600' : ''}
                      ${isCurrent && !isLastCompleted ? 'text-primary-600 font-semibold' : ''}
                      ${isPending ? 'text-gray-400' : ''}
                    `}
                  >
                    {step.label}
                  </p>
                  {isCurrent && step.description && (
                    <p className="text-xs text-gray-500 mt-1 animate-fade-in hidden sm:block">
                      {step.description}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
